/**
 * 路由设置
 */
export default [
  {
    path: '',
    // Relative to /src/views
    name: '概况',
    view: 'Dashboard'
  },
  {
    path: '/user-profile',
    name: '用户信息',
    view: 'UserProfile'
  },
  {
    path: '/table-list',
    name: '表清单',
    view: 'TableList'
  },
  {
    path: '/typography',
    name: '版式',
    view: 'Typography'
  },
  {
    path: '/icons',
    name: '图标',
    view: 'Icons'
  },
  {
    path: '/maps',
    name: '地图',
    view: 'Maps'
  },
  {
    path: '/notifications',
    name: '通知',
    view: 'Notifications'
  }
]
